import Footer from "../../../../shared/components/footer";
import Navbar from "../../../../shared/components/navbar";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import QuoteFormWrapper from "../../../../shared/components/quoteFormWrapper";
import AccordionGroup from "../../../../shared/components/accordionGroup";
import PortalBackButton from "../../components/PortalBackButton";

const PortalDocuments = () => {
  const STATE = useAppStateStore();
  const { archiveItems, archiveItemsActionLinks } = STATE.documents || {};

  return (
    <>
      <Navbar />
      <div className="mainBody">
        <QuoteFormWrapper>
          <div>
            <h1>Portal Documents</h1>

            {(!archiveItems || !archiveItems.length) && (
              <p>No documents to display.</p>
            )}

            {archiveItemsActionLinks?.map((doc, index) => {
              const filteredItems =
                archiveItems?.filter((item) =>
                  doc.linkedVaultArchiveItems.includes(item.archiveId)
                ) || [];

              return (
                <AccordionGroup
                  key={index}
                  header={doc.archiveActionLinkName}
                  items={filteredItems}
                />
              );
            })}
          </div>
        </QuoteFormWrapper>
        <PortalBackButton />
      </div>
      <Footer />
    </>
  );
};

export default PortalDocuments;
